import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Vehicle } from '../../../DataStructures/Vehicle/Vehicle';
import { VehicleReservation } from '../../../DataStructures/VehicleReservation/VehicleReservation';

@Component({
  selector: 'app-vehicle-size-dialog',
  templateUrl: './vehicle-size-dialog.component.html',
  styleUrls: ['./vehicle-size-dialog.component.css']
})
export class VehicleSizeDialogComponent implements OnInit {

  vehicle:Vehicle;
  newSize;
  constructor(public dialogRef: MatDialogRef<VehicleSizeDialogComponent >,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.vehicle = data.vehicle;
      this.newSize = data.newSize;

    }

  ngOnInit() {

  }

  upgrade(){
    this.dialogRef.close('upgrade');
  }

  new(){
    this.dialogRef.close('new');
  }

  cancel(){
    this.dialogRef.close('cancel');
  }

}



// WEBPACK FOOTER //
// ./src/app/admin-dashboard/optimizer/vehicle-size-dialog/vehicle-size-dialog.component.ts